module.exports = __webpack_public_path__ + "img/3.29037eae.jpg";